import React from "react";
import styled from "styled-components";
import {Header, Title} from "./Headings";
import {subduedTextColour} from "../../../style/styleConsts";
import PercentageChange from "../../performance/PercentageChange";
import {StockPageEarnings} from "../earnings/StockEarnings";

const Container = styled.div`
    flex-grow: 0;
`;

const Row = styled.div`
    display: flex;
`;

const RowItem = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    margin-right: ${props => props.isLast ? '0' : '48px'};
`;

const Value = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-top: 6px;
    color: ${subduedTextColour};
    font-size: 24px;
    height: 42px;
`;

const CurrentPrice = ({currentPrice, currency, exchangeDelay}) => {
    const price = currentPrice === null ? "\u2014" : `${currentPrice} ${currency}`;

    return <RowItem className="t-current-price">
        <Title className="t-heading">{"Current Price" + (exchangeDelay ? " (delayed " + exchangeDelay + " mins)" : "")}</Title>
        <Value className="t-value">{price}</Value>
    </RowItem>;
};

const ChangeToday = ({priceChangeToday}) => {
    return <RowItem className="t-price-change-today">
        <Title>% Change Today</Title>
        <Value className="t-value">
            <PercentageChange change={priceChangeToday === null ? null : Number.parseFloat(priceChangeToday)}/>
        </Value>
    </RowItem>;
};

const EarningsContainer = styled.div`
    margin-bottom: 2px;
`;

const Earnings = ({className, title, earningsData, isLast = false}) => {
    return <RowItem className={className} isLast={isLast}>
        <Title>{title}</Title>
        <Value className="t-value">
            <EarningsContainer>
                <StockPageEarnings earnings={earningsData}/>
            </EarningsContainer>
        </Value>
    </RowItem>;
};

const MarketActivity = ({stockDetails}) => {
    const {currency, currentPrice, earnings, priceChangeToday, exchangeDelay} = stockDetails;
    return <Container>
        <Header>Market Activity</Header>
        <Row>
            <CurrentPrice currentPrice={currentPrice} currency={currency} exchangeDelay={exchangeDelay}/>
            <ChangeToday priceChangeToday={priceChangeToday}/>
            <Earnings className="t-previous-earnings" title="Previous Earnings"
                      earningsData={earnings.previousEarnings}/>
            <Earnings className="t-next-earnings" title="Next Earnings" isLast={true}
                      earningsData={earnings.nextEarnings}/>
        </Row>
    </Container>;
}

export default MarketActivity;